import { CLEAR_MODAL, SET_LOADING, SET_MODAL } from 'store/types/common';

export const setModal = (modal) => {
  return {
    type: SET_MODAL,
    payload: modal,
  };
};

export const clearModal = () => {
  return {
    type: CLEAR_MODAL,
    payload: null,
  };
};

export const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading,
  };
};
